// Description: Endpoint to add one google list
// Updated: 21/08/2025
// Author: Simon Franklin

import axios from 'axios';

export async function PostListagens(data) {
  try {
    const token = localStorage.getItem('jwt_token');
    const clientId = localStorage.getItem('idToken');

    if (!token) throw new Error('Token de autenticação não encontrado');
    if (!clientId) throw new Error('ID do cliente não encontrado');

    const response = await axios.post(`${process.env.REACT_APP_BACKEND_AWS_URL}/sheets/google/add`, data, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': token,
        'Client_ID': clientId
      }
    });

    return response.data; // Retorna apenas os dados da resposta
  } catch (error) {
    console.error('Erro ao obter dados da API:', error);
    return { data: [], status: 'Ocorreu um erro na requisição.' };
  }
}
